import { Loader2, CheckCircle2, AlertCircle } from "lucide-react";
import { Badge } from "./ui/badge";

interface ProcessingBadgeProps {
  status: string | null;
}

export function ProcessingBadge({ status }: ProcessingBadgeProps) {
  if (!status || status === 'complete') return null;

  if (status === 'pending' || status === 'processing') {
    return (
      <Badge variant="secondary" className="gap-1.5">
        <Loader2 className="h-3 w-3 animate-spin" />
        Processing...
      </Badge>
    );
  }

  if (status === 'failed') {
    return (
      <Badge variant="destructive" className="gap-1.5">
        <AlertCircle className="h-3 w-3" />
        Processing failed
      </Badge>
    );
  }

  return null;
}
